import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../../../features/auth';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, currentUser, error } = useSelector(state => state.auth);

  useEffect(() => {
    if (isAuthenticated && currentUser) {
      // Route based on admin status
      if (currentUser.isAdmin) {
        navigate('/admin/dashboard');
      } else {
        navigate('/dashboard');
      }
    }
  }, [isAuthenticated, currentUser, navigate]);

  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginUser(credentials));
  };

  return (
    <>
    
    <div className="flex relative justify-center mx-auto accent-color-dark br-5 p-46 box-shadow" style={{ maxWidth: 420 }}>
    {/* <div>
          <h2 className="absolute text-white pl-16">Login</h2>
        </div> */}
    
      <form onSubmit={handleSubmit} className='mt-24 justify-center'>
        <div>
          <input 
            type="text" 
            name="username"
            placeholder='   Enter your username'
            value={credentials.username}
            className='input-box mx-auto'
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <input 
            type={showPassword ? 'text' : 'password'} 
            name="password"
            placeholder='   Enter your password'
            value={credentials.password} 
            className='input-box mx-auto'
            onChange={handleChange}
            required
          />
        </div>
          <div className="policy flex items-center">
              <input
                id="showPassword"
                type="checkbox"
                className='m-8'
                checked={showPassword}
                onChange={(e) => setShowPassword(e.target.checked)}
              />
              <label htmlFor="showPassword" className='text-white py-12'>Show password</label>
          </div>
        <button type="submit" className='px-48 py-18 text-white bg-color-dark no-border bold br-5 w-full md:auto nav-button'>Login</button>
      </form>
      {error && <div className="error-message">{error}</div>}
      </div>
    </>
  )
}

export default Login;
